<div class="resource-error">
	<md-icon class="resource-error__icon" [icon]="content().icon"></md-icon>

	<md-tag class="resource-error__tag">
		<span>{{ content().tag }}</span>
	</md-tag>

	<div class="resource-error__message">
		<div class="md-text-lg-semibold">{{ content().title }}</div>
		<div class="md-text-md-regular">{{ content().message }}</div>
	</div>

	<div class="resource-error__actions">
		@if (backLink()) {
			<a [routerLink]="backLink()" md-button-brand>{{ backLabel() }}</a>
		} @else {
			<button type="button" md-button-brand (click)="goBack()">{{ backLabel() }}</button>
		}
	</div>
</div>
